import { render, staticRenderFns } from "./UseConfigTemplate.vue?vue&type=template&id=383b6997&scoped=true&"
import script from "./UseConfigTemplate.vue?vue&type=script&lang=js&"
export * from "./UseConfigTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b6997",
  null
  
)

export default component.exports